import { preparePayloadForGraphQL } from '@/helpers/validate';

/** `electrician` of the block with its payload type (`preparePayloadForGraphQL`). */
const PROJECT_ROUGH_PLANNING_TOP_LEVEL_FIELD_TYPES = {
  electrician: 'id',
};

/** Fields of `installation` saved by the block, sent flat. */
const PROJECT_ROUGH_PLANNING_INSTALLATION_FIELD_TYPES = {
  operationRegistrationAt: 'date',
  electricMeterChangedAt: 'date',
};

/** Must match `ProjectRoughPlanningInput`. */
export const PROJECT_ROUGH_PLANNING_INPUT_FIELDS = [
  ...Object.keys(PROJECT_ROUGH_PLANNING_TOP_LEVEL_FIELD_TYPES),
  ...Object.keys(PROJECT_ROUGH_PLANNING_INSTALLATION_FIELD_TYPES),
];

/**
 * `ProjectRoughPlanningInput` from the block object: the id of `electrician` and the two dates of
 * `installation`; missing values are sent as null.
 */
export const toProjectRoughPlanningInput = (project) => ({
  ...preparePayloadForGraphQL(
    { electrician: project.electrician ?? null },
    PROJECT_ROUGH_PLANNING_TOP_LEVEL_FIELD_TYPES
  ),
  ...preparePayloadForGraphQL(
    {
      operationRegistrationAt: project.installation?.operationRegistrationAt ?? null,
      electricMeterChangedAt: project.installation?.electricMeterChangedAt ?? null,
    },
    PROJECT_ROUGH_PLANNING_INSTALLATION_FIELD_TYPES
  ),
});
